import styled, { css } from "styled-components"
import CloseIcon from "components/atoms/CloseIcon"

const calculateBoxXPosition = (positionX, boxWidth, overlayWidth) => {
  const absolute = Math.abs(positionX)
  const offset = overlayWidth / 2 - absolute - boxWidth / 2 - 8
  if (positionX > 0 && offset < 0) {
    return css`
      left: ${offset}px;
    `
  }

  if (positionX < 0 && offset < 0) {
    return css`
      left: ${Math.abs(offset)}px;
    `
  }
  return ""
}

const calculateBoxYPosition = (positionY) =>
  positionY >= 0
    ? css`
        transform: translateX(-50%) translateY(-100%) translateY(-1.6rem);
      `
    : css`
        transform: translateX(-50%) translateY(0.8rem);
      `

const calculateAfterXPosition = (positionX, boxWidth, overlayWidth) => {
  const absolute = Math.abs(positionX)
  const offset = overlayWidth / 2 - absolute
  if (offset <= boxWidth / 2 && positionX < 0) {
    return css`
      left: ${offset - 10}px;
    `
  }
  if (offset <= boxWidth / 2 && positionX > 0) {
    return css`
      right: ${offset - 24}px;
      left: initial;
    `
  }
  return ""
}

const calculateAfterYPosition = (positionY) =>
  positionY >= 0 &&
  css`
    top: initial;
    bottom: -2.5rem;
  `

const StyledInfoBoxWrapper = styled.div`
  position: absolute;

  ${({ position }) =>
    position &&
    css`
      width: ${position.overlayWidth}px;
      ${calculateBoxYPosition(position.y)}
      left: ${-position.x}px;
    `}

  ${({ theme }) => theme.mq.medium} {
    left: initial;
    ${({ position }) =>
      position &&
      css`
        width: auto;
        ${calculateBoxXPosition(
          position.x,
          position.boxWidth,
          position.overlayWidth
        )}
      `}

    &:before {
      content: "";
      height: 3.5rem;
      width: 2rem;
      position: absolute;
      top: -2.5rem;
      left: 50%;
      transform: translateX(-50%);
      pointer-events: all;

      ${({ position }) =>
        position &&
        css`
          ${calculateAfterYPosition(position.y)}
          ${calculateAfterXPosition(
            position.x,
            position.boxWidth,
            position.overlayWidth
          )}
        `}
    }
  }
`

const StyledCloseIcon = styled(CloseIcon)`
  width: 50%;
  height: 1px;
`
const StyledCloseButton = styled.button`
  border: none;
  background: none;
  width: 2rem;
  height: 2rem;
  padding: 0.5rem;
  cursor: pointer;
  position: absolute;
  right: 0.8rem;
  top: 0.8rem;

  ${({ theme }) => theme.mq.medium} {
    display: none;
  }
`

export { StyledInfoBoxWrapper, StyledCloseIcon, StyledCloseButton }
